'use strict';

app.controller('WorktimeSettingCtrl', [
    '$scope',
    '$http',
    '$translate',
    'toaster',
    function($scope, $http, $translate, toaster) {
        $scope.loading = false;

        $scope.worktimeSettings = [];
        $scope.worktimeSettingsLength = 0;

        $scope.types = [
            { text: 'default', value: '0' },
            { text: 'ignition', value: '1' },
            { text: 'rpm', value: '2' },
            { text: 'can', value: '3' },
        ];

        $scope.buildUpdatePayload = function(worktimeSetting) {
            var payload = {
                objectId: worktimeSetting.object.objectId,
                type: worktimeSetting.type.value,
            };

            return payload;
        };
        $scope.updateType = function(worktimeSetting) {
            var payload = $scope.buildUpdatePayload(worktimeSetting);

            $http.post('/api/worktimeSetting/update', payload).then(
                function() {
                    toaster.pop({
                        type: 'success',
                        title: $translate.instant(
                            'general.toastr.success.header'
                        ),
                        body: $translate.instant(
                            'general.toastr.success.form.action.update'
                        ),
                    });
                },
                function() {
                    toaster.pop({
                        type: 'error',
                        title: $translate.instant(
                            'general.toastr.error.header'
                        ),
                        body: $translate.instant(
                            'general.toastr.error.form.action.update'
                        ),
                    });
                }
            );
            return true;
        };

        $scope.list = function() {
            $scope.loading = true;
            $scope.worktimeSettings = [];

            $http.get('/api/worktimeSetting/list').then(
                function(response) {
                    var worktimeSettings = (response.data.data || {})
                        .worktimeSettings;
                    $scope.worktimeSettings =
                        worktimeSettings !== void 0 ? worktimeSettings : [];
                    $scope.worktimeSettingsLength = Object.keys(
                        worktimeSettings
                    ).length;
                    $scope.loading = false;
                },
                function() {
                    $scope.loading = false;
                }
            );
        };
        $scope.init = function() {
            $scope.list();
        };
        $scope.init();
    },
]);
